import { Logout } from "@mui/icons-material";
import {
  Box,
  Divider,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  MenuItem as MuiMenuItem,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import { ThemeSwitch } from "@synota-io/synota-shared-ui";
import { useNavigate } from "react-router-dom";
import { useLogout } from "../../api/hooks/useLogout";
import { ACCOUNT_LOGIN_PATH } from "../../paths";
import { useAuth } from "../../api/auth/useAuth";

export const ProfileMenu = () => {
  const navigate = useNavigate();
  const { isAdmin, toggleUserView, self } = useAuth();
  const { logout, isPending } = useLogout();
  return (
    <>
      <ListSubheader>
        <Stack direction="row" alignItems="center" spacing={4} pb={3} pt={2}>
          <Typography variant="subtitle1">{isAdmin ? "Admin" : "Profile"}</Typography>
          <Box flexGrow={1} />
          <ThemeSwitch />
        </Stack>
      </ListSubheader>

      {self?.is_synota_admin ? (
        <ListSubheader>
          <Stack direction="row" alignItems="center" spacing={4} pb={3} pt={2}>
            <Typography variant="subtitle1">User View</Typography>
            <Box flexGrow={1} />
            <Switch
              checked={!isAdmin}
              onChange={() => {
                toggleUserView();
              }}
            />
          </Stack>
        </ListSubheader>
      ) : null}

      <Divider />

      <MuiMenuItem
        disabled={isPending}
        onClick={() => {
          logout(
            { logout_all_sessions: false },
            {
              onSuccess: () => {
                navigate(ACCOUNT_LOGIN_PATH);
              },
            },
          );
        }}
      >
        <ListItemIcon>
          <Logout fontSize="small" />
        </ListItemIcon>
        <ListItemText>Logout</ListItemText>
      </MuiMenuItem>
    </>
  );
};
